import React from "react";
import { useLanguage } from "../contexts/LanguageContext";

const COPY = {
  en: {
    title: "Privacy Policy",
    updated: "Last updated: 08/07/2025",
    sections: [
      {
        title: "1. Who we are",
        body: (
          <p>
            Chesshood Ltd
            <br />
            30 Stuart Crescent, Winchester SO22 4AU, United Kingdom
            <br />
            Email: <a href="mailto:chesshood@chesshood.com">chesshood@chesshood.com</a>
          </p>
        ),
      },
      {
        title: "2. What data we collect",
        body: (
          <p>
            We collect information you provide directly, plus technical,
            gameplay, analytics and crash information needed to run and improve
            Chesshood.
          </p>
        ),
      },
      {
        title: "3. How and why we use your data",
        body: (
          <ul>
            <li>Account and login</li>
            <li>Payments and fraud prevention</li>
            <li>Analytics and product improvement</li>
            <li>Advertising and ad delivery</li>
          </ul>
        ),
      },
      {
        title: "4. Third-party processors",
        body: (
          <ul>
            <li>Firebase</li>
            <li>Stripe</li>
            <li>Google Analytics 4</li>
            <li>Cloudflare</li>
            <li>Google AdMob</li>
          </ul>
        ),
      },
      {
        title: "5. Your rights",
        body: (
          <p>
            You may access, rectify, erase, restrict, port or object to the
            processing of your personal data, and withdraw consent at any time.
          </p>
        ),
      },
      {
        title: "6. Children",
        body: (
          <p>
            The service is not directed to children under 13. If we learn that a
            child under 13 opened an account, we will remove it promptly.
          </p>
        ),
      },
      {
        title: "7. Security",
        body: (
          <p>
            We use TLS encryption, hashed passwords and least-privilege access
            controls.
          </p>
        ),
      },
      {
        title: "8. Complaints",
        body: (
          <p>
            You may lodge a complaint with the ICO at{" "}
            <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">
              ico.org.uk
            </a>
            .
          </p>
        ),
      },
      {
        title: "9. Changes",
        body: <p>We will post changes on this page.</p>,
      },
      {
        title: "10. Account deletion",
        body: (
          <p>
            You can delete your Chesshood account via{" "}
            <a
              href="https://chesshood.com/profile?showDelete=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              your profile
            </a>
            .
          </p>
        ),
      },
      {
        title: "11. Data retention",
        body: (
          <p>
            We keep data for as long as needed to provide the service, improve
            the product and comply with legal obligations.
          </p>
        ),
      },
      {
        title: "12. SDKs and cookies",
        body: (
          <p>
            We may use Firebase, AdMob and GA4. In UK/EU/EEA we obtain consent
            where required before using identifiers for personalised ads or
            analytics beyond strictly necessary purposes.
          </p>
        ),
      },
      {
        title: "13. Ad choices",
        body: (
          <p>
            You can manage ad choices in device settings and at{" "}
            <a
              href="https://adssettings.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              adssettings.google.com
            </a>
            .
          </p>
        ),
      },
    ],
  },
  pl: {
    title: "Polityka prywatnosci",
    updated: "Ostatnia aktualizacja: 08/07/2025",
    sections: [
      {
        title: "1. Kim jestesmy",
        body: (
          <p>
            Chesshood Ltd
            <br />
            30 Stuart Crescent, Winchester SO22 4AU, United Kingdom
            <br />
            Email: <a href="mailto:chesshood@chesshood.com">chesshood@chesshood.com</a>
          </p>
        ),
      },
      {
        title: "2. Jakie dane zbieramy",
        body: (
          <p>
            Zbieramy dane podane bezposrednio przez uzytkownika oraz dane
            techniczne, treningowe, analityczne i diagnostyczne potrzebne do
            dzialania i rozwoju Chesshood.
          </p>
        ),
      },
      {
        title: "3. Jak i dlaczego uzywamy danych",
        body: (
          <ul>
            <li>konto i logowanie</li>
            <li>platnosci i przeciwdzialanie naduzyciom</li>
            <li>analityka i rozwoj produktu</li>
            <li>reklamy i dostarczanie reklam</li>
          </ul>
        ),
      },
      {
        title: "4. Podmioty przetwarzajace",
        body: (
          <ul>
            <li>Firebase</li>
            <li>Stripe</li>
            <li>Google Analytics 4</li>
            <li>Cloudflare</li>
            <li>Google AdMob</li>
          </ul>
        ),
      },
      {
        title: "5. Twoje prawa",
        body: (
          <p>
            Masz prawo dostepu, sprostowania, usuniecia, ograniczenia,
            przenoszenia danych oraz wycofania zgody w dowolnym momencie.
          </p>
        ),
      },
      {
        title: "6. Dzieci",
        body: (
          <p>
            Serwis nie jest kierowany do dzieci ponizej 13 roku zycia. Jesli
            dowiemy sie o takim koncie, usuniemy je niezwlocznie.
          </p>
        ),
      },
      {
        title: "7. Bezpieczenstwo",
        body: (
          <p>
            Stosujemy szyfrowanie TLS, hashowanie hasel i zasade minimalnych
            uprawnien.
          </p>
        ),
      },
      {
        title: "8. Skargi",
        body: (
          <p>
            Mozesz zlozyc skarge do ICO:{" "}
            <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">
              ico.org.uk
            </a>
            .
          </p>
        ),
      },
      {
        title: "9. Zmiany",
        body: <p>Zmiany beda publikowane na tej stronie.</p>,
      },
      {
        title: "10. Usuniecie konta",
        body: <p>Konto Chesshood mozna usunac przez profil.</p>,
      },
      {
        title: "11. Retencja danych",
        body: (
          <p>
            Dane przechowujemy tak dlugo, jak to konieczne do swiadczenia uslugi,
            rozwoju produktu i wypelnienia obowiazkow prawnych.
          </p>
        ),
      },
      {
        title: "12. SDK i cookies",
        body: (
          <p>
            Mozemy korzystac z Firebase, AdMob i GA4. W UK/EU/EEA uzyskujemy
            zgode tam, gdzie jest wymagana przed personalizacja reklam lub
            analityka wykraczajaca poza cele niezbedne.
          </p>
        ),
      },
      {
        title: "13. Ustawienia reklam",
        body: (
          <p>
            Ustawienia reklam mozna zmieniac w urzadzeniu oraz na{" "}
            <a
              href="https://adssettings.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              adssettings.google.com
            </a>
            .
          </p>
        ),
      },
    ],
  },
  es: {
    title: "Politica de privacidad",
    updated: "Ultima actualizacion: 08/07/2025",
    sections: [
      {
        title: "1. Quienes somos",
        body: (
          <p>
            Chesshood Ltd
            <br />
            30 Stuart Crescent, Winchester SO22 4AU, United Kingdom
            <br />
            Email: <a href="mailto:chesshood@chesshood.com">chesshood@chesshood.com</a>
          </p>
        ),
      },
      {
        title: "2. Que datos recopilamos",
        body: (
          <p>
            Recopilamos datos proporcionados por el usuario y datos tecnicos, de
            entrenamiento, analiticos y de diagnostico necesarios para operar y
            mejorar Chesshood.
          </p>
        ),
      },
      {
        title: "3. Como y por que usamos los datos",
        body: (
          <ul>
            <li>cuenta e inicio de sesion</li>
            <li>pagos y prevencion de fraude</li>
            <li>analitica y mejora del producto</li>
            <li>publicidad y entrega de anuncios</li>
          </ul>
        ),
      },
      {
        title: "4. Procesadores externos",
        body: (
          <ul>
            <li>Firebase</li>
            <li>Stripe</li>
            <li>Google Analytics 4</li>
            <li>Cloudflare</li>
            <li>Google AdMob</li>
          </ul>
        ),
      },
      {
        title: "5. Tus derechos",
        body: (
          <p>
            Puedes acceder, rectificar, borrar, limitar, portar datos y retirar
            tu consentimiento en cualquier momento.
          </p>
        ),
      },
      {
        title: "6. Menores",
        body: (
          <p>
            El servicio no esta dirigido a menores de 13 anos. Si detectamos una
            cuenta de ese tipo, la eliminaremos rapidamente.
          </p>
        ),
      },
      {
        title: "7. Seguridad",
        body: (
          <p>
            Utilizamos cifrado TLS, contrasenas con hash y acceso de minimo
            privilegio.
          </p>
        ),
      },
      {
        title: "8. Reclamaciones",
        body: (
          <p>
            Puedes presentar una reclamacion ante ICO:{" "}
            <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">
              ico.org.uk
            </a>
            .
          </p>
        ),
      },
      {
        title: "9. Cambios",
        body: <p>Los cambios se publicaran en esta pagina.</p>,
      },
      {
        title: "10. Eliminacion de cuenta",
        body: <p>La cuenta Chesshood puede eliminarse desde el perfil.</p>,
      },
      {
        title: "11. Conservacion de datos",
        body: (
          <p>
            Conservamos los datos el tiempo necesario para prestar el servicio,
            mejorar el producto y cumplir las obligaciones legales.
          </p>
        ),
      },
      {
        title: "12. SDK y cookies",
        body: (
          <p>
            Podemos utilizar Firebase, AdMob y GA4. En UK/EU/EEA obtenemos
            consentimiento cuando es necesario antes de personalizar anuncios o
            analitica no estrictamente necesaria.
          </p>
        ),
      },
      {
        title: "13. Opciones de anuncios",
        body: (
          <p>
            Puedes cambiar tus opciones en el dispositivo y en{" "}
            <a
              href="https://adssettings.google.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              adssettings.google.com
            </a>
            .
          </p>
        ),
      },
    ],
  },
};

export default function PrivacyPolicy() {
  const { language } = useLanguage();
  const copy = COPY[language] || COPY.en;

  return (
    <div className="privacy-policy">
      <h1>{copy.title}</h1>
      <p>
        <strong>{copy.updated}</strong>
      </p>
      {copy.sections.map((section) => (
        <section key={section.title}>
          <h2>{section.title}</h2>
          {section.body}
        </section>
      ))}
    </div>
  );
}
